
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IItem, instanceOfINameDisplayable } from "../../../../../../../domain/document/items";
import { InjectedObjectGroundModel, InjectedObjectModel } from "../models";

@Component
export default class InjectedObjectPresentableMixin extends Mixins() {
  @Prop()
  source: InjectedObjectModel;

  get id(): string | null {
    return this.source.source.id;
  }

  get target(): IItem | null {
    return this.source.target;
  }

  get label(): string | null {
    return this.source.source.label
      ? this.source.source.label
      : instanceOfINameDisplayable(this.target) ? this.target.getDisplayName() : this.source.source.key;
  }

  get value(): string {
    return this.source.source.value;
  }

  get grounds(): InjectedObjectGroundModel[] {
    return this.source.grounds;
  }
}
